import React from "react";
import NotFound from "./404";

export default function NotFoundPage() {
      return (
      <div className="page">
        <NotFound />
      </div>
    );
}